<template>
  <div class="min-h-screen m-3">
    <el-card>
      <div class="border-b-0.5 flex justify-between items-center my-1">
        <p class="text-sm font-semibold w-full">List of Employee Timeoffs</p>
      </div>
      <transition name="fade">
        <div
          v-if="loading"
          class="inset-0 absolute z-50 bg-black bg-opacity-10 w-full"
        >
          <loader class="center-h-v" />
        </div>
      </transition>
      <transition name="fade">
        <div
          v-if="delete_success"
          class="p-1 text-center text-sm w-full bg-green-200"
        >
          {{ delete_success }}
        </div>
      </transition>
      <transition name="fade">
        <div
          v-if="delete_error"
          class="p-1 text-center text-sm w-full bg-yellow-200"
        >
          {{ delete_error }}
        </div>
      </transition>
      <transition name="fade">
        <div
          v-if="get_error"
          class="p-1 text-center text-sm w-full bg-yellow-200"
        >
          {{ get_error }}
        </div>
      </transition>

      <transition name="fade">
        <div
          v-if="assign_success"
          class="p-1 text-center text-sm w-full bg-green-200"
        >
          {{ assign_success }}
        </div>
      </transition>
      <transition name="fade">
        <div
          v-if="assign_error"
          class="p-1 text-center text-sm w-full bg-yellow-200"
        >
          {{ assign_error }}
        </div>
      </transition>

      <div class="flex justify-between items-center pl-0 ml-0 p-2">
        <div class="flex justify-between items-left">
          <el-pagination
            background
            @size-change="handleSizeChange"
            :page-sizes="pageSizes"
            :page-index="pageIndex"
            :page-size="pageSize"
            layout="sizes"
            :total="tableData.length"
          >
          </el-pagination>

          <!-- search -->
          <input
            v-model="searchInput"
            type="search"
            placeholder="Start typing to search..."
            class="bg-gray-200 w-52 py-1 rounded-md"
          />
          <!-- search -->
        </div>

        <div class="flex flex-wrap whitespace-nowrap gap-2">
          <button
            @click="showBulkUpload = true"
            class="border-1.5 rounded-full p-1.5 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex gap-1 capitalize"
            style="
              justify-items: center;
              align-items: center;
              justify-content: center;
            "
          >
            <img class="h-5" src="@/assets/icons/export-excel.png" />
            Import
          </button>
          <button
            @click="exportTemplate"
            class="border-1.5 rounded-full px-2 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex gap-1 capitalize"
            style="
              justify-items: center;
              align-items: center;
              justify-content: center;
            "
          >
            <img class="h-5" src="@/assets/icons/export-excel.png" />
            Export
          </button>
        </div>
      </div>
      <div>
        <ve-table
          :table-data="filteredTableData"
          :columns="columns"
          row-key-field-name="EmployeeNo"
        ></ve-table>

        <div
          v-if="!filteredTableData.length"
          class="flex flex-col justify-center items-center h-full mt-5"
        >
          <el-empty :image-size="70" description="No Data"></el-empty>
        </div>
      </div>
    </el-card>

    <!-- Create multiple employees -->
    <BulkUpload
      v-if="showBulkUpload"
      :close="close"
      :showBulkUpload="showBulkUpload"
      :showBulkUploadCallback="showBulkUploadCallback"
      :title="title"
      dataType="EmployeeTimeoffTypes"
      :url="url"
      :dateColumns="[]"
      :columns="resultColumns"
    ></BulkUpload>
  </div>
</template>

<script>
import axios from "axios";
import loader from "../loader/loader.vue";
import { mapGetters } from "vuex";
import { importTemplateGenerator } from "@/utils/importTemplateGenerator";

export default {
  name: "timeoffBulkUpload",
  components: {
    loader,
    BulkUpload: () => import("@/utils/bulkUploadsUtils.vue"),
  },
  data() {
    return {
      showBulkUpload: false,
      title: "Employee Timeoff Types",
      loading: false,
      searchInput: "",
      url: `/employee/timeoff/type/bulk/v1/assign`,
      // page index
      pageIndex: 1,
      // page size
      assign_error: null,
      assign_success: null,
      delete_error: null,
      delete_success: null,
      pageSize: 10,
      get_error: null,
      get_success: null,
      pageSizes: [],
      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 50,
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "EmployeeNo",
          key: "EmployeeNo",
          title: "Employee No",
          headerAlign: "left",
          align: "left",
          sampleValue: "EMPLOYEE-001",
        },
        {
          field: "EmployeeName",
          key: "EmployeeName",
          title: "Employee Name",
          headerAlign: "center",
          align: "left",
        },
      ],
      resultColumns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 50,
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "EmployeeNo",
          key: "EmployeeNo",
          title: "Employee No",
          headerAlign: "left",
          align: "left",
        },
        {
          field: "TimeoffType",
          key: "TimeoffType",
          title: "Timeoff Type",
          headerAlign: "center",
          align: "left",
        },
      ],
      tableData: [
        // {
        //   EmployeeNo: "DP-233",
        //   EmployeeName: "Tom",
        //   leaveTypes: [
        //     {
        //       leaveType: "Annual",
        //     },
        //     {
        //       leaveType: "Paternity",
        //     },
        //   ],
        // },
        // {
        //   EmployeeNo: "DP-234",
        //   EmployeeName: "John",
        //   leaveTypes: [
        //     {
        //       leaveType: "Annual",
        //     },
        //     {
        //       leaveType: "Sick Leave",
        //     },
        //   ],
        // },
        // {
        //   EmployeeNo: "DP-235",
        //   EmployeeName: "Morgan",
        //   leaveTypes: [
        //     {
        //       leaveType: "Annual",
        //     },
        //     {
        //       leaveType: "Study",
        //     },
        //   ],
        // },
        // {
        //   EmployeeNo: "DP-236",
        //   EmployeeName: "Jessy",
        //   leaveTypes: [
        //     {
        //       leaveType: "Annual",
        //     },
        //     {
        //       leaveType: "Maternity",
        //     },
        //   ],
        // },
      ],
      organizationLeaveTypes: [],
    };
  },
  computed: {
    ...mapGetters([
      "getOrganization",
      "getToken",
      "getUserType",
      "getCurrentEmployeeId",
      "getVersion",
    ]),
    filteredTableData() {
      const searchTerm = this.searchInput.toLowerCase();
      return this.tableData.filter(
        (row) =>
          row.EmployeeNo.toLowerCase().includes(searchTerm) ||
          row.EmployeeName.toLowerCase().includes(searchTerm) ||
          row.leaveTypes.some((lt) =>
            lt.leaveType.toLowerCase().includes(searchTerm)
          )
      );
    },
  },
  created() {
    this.getLeaveTypes();
  },
  methods: {
    showBulkUploadCallback() {
      this.showBulkUpload = false;
    },
    close() {
      this.showBulkUpload = false;
    },
    exportTemplate() {
      let templateColumns = this.columns
        .filter((c) => c.field !== "EmployeeName")
        .map((c) => {
          if (c.field === "EmployeeNo") {
            return c; // Keep EmployeeNo as it is
          } else {
            // Split the field at uppercase characters and create a new object
            return {
              ...c, // Keep all other properties the same
              field: c.field.replace(/([a-z])([A-Z])/g, "$1 $2"), // Modify the field
            };
          }
        });

      importTemplateGenerator(
        templateColumns,

        "EmployeeTimeoffTypes",
        [],
        [],
        true
      );
    },

    projectTable() {
      this.organizationLeaveTypes.map((leave, i) => {
        this.columns.push({
          field: leave.Name,
          key: leave.Name,
          title: leave.Name,
          headerAlign: "left",
          align: "center",
          sampleValue: i % 3 === 0 ? "NO" : "YES",
          renderBodyCell: ({ rowIndex }) => {
            const leaveTypeName = leave.Name;
            const isLeaveTypeExist = this.tableData[rowIndex].leaveTypes.some(
              (lt) => lt.leaveType === leaveTypeName
            );
            let isChecked = isLeaveTypeExist;

            // Click event handler for the checkbox
            const toggleLeaveType = () => {
              const employee = this.tableData[rowIndex];
              const employeeId = employee.EmployeeNo;
              const leaveTypeId = leave.Id; // Assuming you have an ID for leave types

              if (isChecked) {
                // Unassign leave type
                this.unassignLeaveType(employeeId, leaveTypeId);
              } else {
                // Assign leave type
                this.assignLeaveType(employeeId, leaveTypeId);
              }
            };

            return (
              <input
                class="cursor-pointer"
                type="checkbox"
                v-model={isChecked}
                onClick={toggleLeaveType}
              />
            );
          },
        });
      });
    },

    async assignLeaveType(employeeId, leaveTypeId) {
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      try {
        // Make an API call to assign the leave type
        const response = await axios.post(
          `${this.getOrganization}/employee/leave/type/${this.$ApiVersion}/assign`,
          {
            EmployeeId: employeeId,
            LeaveTypeId: leaveTypeId,
          },
          options
        );
        this.loading = true;
        if (response.data.StatusCode === 200) {
          this.loading = false;
          this.assign_success = response.data.StatusMessage;
          this.refresh();
          setTimeout(() => {
            this.assign_success = null;
          }, 2000);
        } else {
          this.loading = false;
          this.assign_error = response.data.StatusMessage;
          setTimeout(() => {
            this.assign_error = null;
          }, 2000);
        }
      } catch (error) {
        this.loading = false;
        this.cancel_error = error.message;
        setTimeout(() => {
          this.cancel_error = null;
        }, 2000);
      }
    },
    async unassignLeaveType(employeeId, employeeLeaveTypeId) {
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
        data: {
          EmployeeId: employeeId,
          EmployeeLeaveTypeId: employeeLeaveTypeId,
        },
      };
      try {
        // Make an API call to unassign the leave type
        const response = await axios.delete(
          `${this.getOrganization}/employee/leave/type/${this.$ApiVersion}/delete`,

          options
        );

        this.loading = true;
        if (response.data.StatusCode === 200) {
          this.loading = false;
          this.delete_success = response.data.StatusMessage;
          setTimeout(() => {
            this.delete_success = null;
          }, 2000);
        } else {
          this.loading = false;
          this.delete_error = response.data.StatusMessage;
          setTimeout(() => {
            this.delete_error = null;
          }, 2000);
        }
      } catch (error) {
        this.loading = false;
        this.cancel_error = error.message;
        setTimeout(() => {
          this.cancel_error = null;
        }, 2000);
      }
    },
    getLeaveTypes() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/leavetype/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            if (response.data.StatusCode === 200) {
              this.get_success = response.data.StatusMessage;
              this.organizationLeaveTypes = response.data.Data;
              //console.log(this.organizationLeaveTypes);
              this.loading = false;
              this.projectTable();
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
            setTimeout(() => {
              this.showEditError = false;
            }, 2000);
          }
        );
    },

    handleEdit(index, row) {
      index, row;
    },
    handleDelete(index, row) {
      index, row;
    },

    handleSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    setPageSizes() {
      // Generate the page sizes array using a loop
      for (let i = 1; i <= 10; i++) {
        this.pageSizes.push(this.pageSize * i);
      }
    },
    // page number change
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },
  },
};
</script>

<style>
.ve-table-body-td {
  z-index: -2;
}

.el-input.el-input--mini.el-input--suffix .el-input__inner {
  height: 30px !important;
  background-color: #fff !important;
  border-radius: 0 !important;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  margin-left: 0 !important;
}
</style>
